import { useState } from "react";
import { ApiError, type ApiClient, type AuthSession } from "../api/client.js";

export function LoginPage(props: {
  api: ApiClient;
  onAuthenticated: (session: AuthSession) => void;
  tenantId?: string | undefined;
}): React.JSX.Element {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(): Promise<void> {
    setSubmitting(true);
    setError(null);
    try {
      const tenantId = props.tenantId?.trim();
      if (!tenantId) {
        setError("登录入口尚未配置，请联系管理员。");
        return;
      }
      const session = await props.api.login({ email, password, tenantId });
      props.onAuthenticated(session);
    } catch (cause) {
      const detail = cause instanceof ApiError
        ? loginErrorMessage(cause)
        : cause instanceof Error
          ? cause.message
          : "UNKNOWN_ERROR";
      setError(`登录失败：${detail}`);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main>
      <h1>SCS 催收协作台</h1>
      <form onSubmit={(event) => { event.preventDefault(); void submit(); }}>
        <label>
          邮箱
          <input
            autoComplete="username"
            onChange={(event) => { setEmail(event.currentTarget.value); }}
            required
            type="email"
            value={email}
          />
        </label>
        <label>
          密码
          <input
            autoComplete="current-password"
            minLength={12}
            onChange={(event) => { setPassword(event.currentTarget.value); }}
            required
            type="password"
            value={password}
          />
        </label>
        {error === null ? null : <p role="alert">{error}</p>}
        <button
          disabled={submitting}
          type="submit"
        >
          {submitting ? "登录中…" : "登录"}
        </button>
      </form>
    </main>
  );
}

function loginErrorMessage(error: ApiError): string {
  if (error.code !== "INVALID_REQUEST") return error.code;
  const fields = isRecord(error.details) && Array.isArray(error.details["fields"])
    ? error.details["fields"].filter((field): field is string => typeof field === "string")
    : [];
  const labels = fields.map((field) => ({
    email: "邮箱",
    password: "密码（至少 12 位）",
    tenantId: "登录入口配置"
  })[field] ?? field);
  return labels.length === 0
    ? "登录信息格式不正确"
    : `请检查：${labels.join("、")}`;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
